import React from "react";
import { Box, Typography, Link } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import styles from "./metricsCard.module.scss";

interface MetricsCardProps {
  title: string;
  value: string;
  amount?: string;
  percentage?: string;
  percentageLabel?: string;
  chatLink?: boolean;
}

const MetricsCard: React.FC<MetricsCardProps> = ({
  title,
  value,
  amount,
  percentage,
  percentageLabel,
  chatLink = true,
}) => {
  return (
    <Box className={styles.metricsCard}>
      <Typography variant="body2" className={styles.title}>
        {title}
      </Typography>
      <Typography variant="h3" className={styles.value}>
        {value}
      </Typography>
      {amount && (
        <Typography variant="body2" className={styles.amount}>
          {amount}
        </Typography>
      )}
      {percentage && (
        <Typography variant="body2" className={styles.percentageText}>
          <span className={styles.percentage}>{percentage}</span>
          {percentageLabel && ` ${percentageLabel}`}
        </Typography>
      )}
      {chatLink && (
        <Link href="#" className={styles.chatLink} aria-label="Chat with Data">
          <ChatBubbleOutlineIcon className={styles.chatIcon} />
        </Link>
      )}
    </Box>
  );
};

export default MetricsCard;
